import React, { useState } from 'react';

const SalaryCalculator = () => {
  const [grossPay, setGrossPay] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleCalculate = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    const g = Number(grossPay);
    if (!g || g <= 0) {
      setError('Please enter a valid gross salary amount.');
      return;
    }

    const NSSF = Math.min(g * 0.06, 6480);
    const SHA = g * 0.0275;
    const PAYE = Math.max(0, (g - 24000 - NSSF - SHA) * 0.3 - 2400);
    const HOUSING = g * 0.015;
    const LEVY = g * 0.01;
    const net = g - NSSF - SHA - PAYE - HOUSING - LEVY;

    setResult({
      NSSF,
      SHA,
      PAYE,
      HOUSING,
      LEVY,
      net,
      needs: net * 0.5,
      wants: net * 0.3,
      savings: net * 0.2
    });
  };

  const formatNum = (n) => Math.round(n).toLocaleString();

  return (
    <div>
      <h3>💰 Salary &amp; Tax</h3>
      <form onSubmit={handleCalculate}>
        <input
          type="number"
          id="grossPay"
          placeholder="Gross Salary (KES)"
          value={grossPay}
          onChange={(e) => setGrossPay(e.target.value)}
          step="1"
          min="0"
        />
        <button type="submit" className="btn-main">
          Calculate Net &amp; Budget
        </button>
      </form>

      {error && (
        <div className="error" role="alert">
          <span className="error-icon">⚠️</span>
          {error}
        </div>
      )}

      {result && (
        <div className="results">
          <div className="results-header">
            <span className="results-icon">✅</span>
            <span className="results-title">Deductions &amp; Budget</span>
          </div>
          <div className="results-content">
            <div className="result-item">
              <span className="result-label">NSSF</span>
              <span className="result-value">KES {formatNum(result.NSSF)}</span>
            </div>
            <div className="result-item">
              <span className="result-label">SHA</span>
              <span className="result-value">KES {formatNum(result.SHA)}</span>
            </div>
            <div className="result-item">
              <span className="result-label">PAYE</span>
              <span className="result-value">KES {formatNum(result.PAYE)}</span>
            </div>
            <div className="result-item">
              <span className="result-label">Housing Levy</span>
              <span className="result-value">KES {formatNum(result.HOUSING)}</span>
            </div>
            <div className="result-item">
              <span className="result-label">Other Levy</span>
              <span className="result-value">KES {formatNum(result.LEVY)}</span>
            </div>
            <div className="result-item highlight">
              <span className="result-label">Net Pay</span>
              <span className="result-value">KES {formatNum(result.net)}</span>
            </div>
            <div className="result-item info">
              <span className="result-label">Budget (50/30/20)</span>
              <span className="result-value">—</span>
            </div>
            <div className="result-item">
              <span className="result-label">Needs (50%)</span>
              <span className="result-value">KES {formatNum(result.needs)}</span>
            </div>
            <div className="result-item">
              <span className="result-label">Wants (30%)</span>
              <span className="result-value">KES {formatNum(result.wants)}</span>
            </div>
            <div className="result-item">
              <span className="result-label">Savings (20%)</span>
              <span className="result-value">KES {formatNum(result.savings)}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SalaryCalculator;
